import { useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { rolesColors, rolesTranslations } from '../../services/data'
import { getReplacementMembers } from '../../services/util'

export function ReassignMissionsDepartment({ closePopup, department, vids = [], team, deleteDepartment, transfer = true }) {
    const navigate = useNavigate()
    const admin = team.members.find(m => m.roles.includes('admin'))
    const videos = useRef(vids.map(video => ({ status: video.status, title: video.ideaMaker.titles[0], thumbnail: video.ideaMaker.thumbnails[0], _id: video._id })))
    const [showImg, setShowImg] = useState(false)
    const [options, setOptions] = useState(videos.current.map(video => ({
        selceted: admin,
        availableMembers: getReplacementMembers(team, video.status.level, department.name)
    })))

    const onSelectChange = (e, idx) => {
        let newOptions = [...options]
        newOptions[idx].selceted = e.target.value
        setOptions(newOptions)
    }

    const onDelete = async () => {
        const transfer = videos.current.map((video, idx) => ({
            videoId: video._id,
            newWorkerId: options[idx].selceted
        }))
        await deleteDepartment(department.name, transfer)
        closePopup()
    }

    return <>
        <div className="screen blur" onClick={closePopup} />

        <section className='popup reassign-missions'>
            {(videos.current.length || !transfer) ? <>
                <h1 style={{ marginBottom: '20px', textAlign: 'center' }}>
                    {transfer ? 'לפני שתמחק את מחלקת  ' + department.name + 'יש לחלק את המשימות שלה לעובדים אחרים' : 'המשימות של ' + department.name + ' :'}
                </h1>
                <div className='videos-container'>
                    {videos.current.map((video, idx) => <div key={video._id} className='video-line'>
                        <p onClick={() => navigate(`/video/${video._id}`)} onMouseEnter={() => { if (video.thumbnail) setShowImg(video._id) }} onMouseLeave={() => setShowImg(false)}>{video.title}
                            <span className={rolesColors[video.status.level] + '-text'}> ({rolesTranslations[video.status.level]})</span> </p>
                        {showImg === video._id && <img src={video.thumbnail} alt={video.title} />}
                        {transfer && <select onChange={e => onSelectChange(e, idx)}>
                            {options[idx].availableMembers.map(m => <option key={m._id} value={m._id}>{m.name}</option>)}
                        </select>}
                    </div>)}
                </div>
            </> :
                <h1 style={{ marginBottom: '20px', textAlign: 'center' }}>{' האם אתה בטוח שברצונך למחוק את מחלקת ' + department.name}</h1>}

            <div className='buttons-wrapper' style={{ marginTop: '40px' }}>
                <button className='lighter' onClick={closePopup}>סגור</button>
                {transfer && <button className='bolder red' onClick={onDelete}>מחק מחלקה</button>}
            </div>
        </section>
    </>
}